import { kayaCRUD } from "../../../actions/kaya";
import { selector } from "../../../api";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { buildingCRUD } from "../../../actions/building";
import Select from "react-select";

const kayaSchema = Yup.object().shape({
  head_phone_number: Yup.string().required("Head phone number is required"),
});

const initialValues = {
  code: 1001,
  head_phone_number: "",
  elecricity_meter_no: "",
  water_meter_no: "",
  distance_to_health_center: null,
  distance_to_market: null,
  distance_to_education_center: null,
  distance_to_water_source: null,
  is_toilet_available: true,
  remarks: "",
  description: "",
  building_id: "",
};

export const AddKaya = (props) => {
  const { setIndex, index, buildingId } = props;

  const user = selector.User();
  const [loading, setLoading] = useState(false);
  const [building, setBuilding] = useState([]);
  const [value, setValue] = useState("");
  const [selectedBuilding, setSelectedBuilding] = useState(null);

  const formik = useFormik({
    initialValues,
    validationSchema: kayaSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const {
        code,
        head_phone_number,
        elecricity_meter_no,
        water_meter_no,
        distance_to_health_center,
        distance_to_market,
        distance_to_education_center,
        distance_to_water_source,
        is_toilet_available,
        remarks,
        description,
        building_id,
      } = values;
      const recorded_by = user.id;
      const data = {
        code,
        head_phone_number,
        elecricity_meter_no,
        water_meter_no,
        distance_to_health_center,
        distance_to_market,
        distance_to_education_center,
        distance_to_water_source,
        is_toilet_available,
        remarks,
        recorded_by,
      };
      setLoading(true);
      setTimeout(() => {
        kayaCRUD
          .addKaya(data)
          .then((resp) => {
            const kaya_id = resp.data.id;

            // Only create building-kaya relationship if building is selected
            if (building_id) {
              const kayaBuilding = {
                kaya_id,
                description,
                building_id,
                recorded_by,
              };
              kayaCRUD
                .addKayaBuilding(kayaBuilding)
                .then(() => {
                  toast.success("New Kaya has been registered.", {
                    autoClose: 7000,
                  });
                  setIndex(index + 1);
                  setLoading(false);
                  setSubmitting(false);
                  resetForm();
                })
                .catch((error) => {
                  toast.error(error.message, { autoClose: 7000 });
                  setLoading(false);
                  setSubmitting(false);
                });
            } else {
              // No building selected, just complete the kaya registration
              toast.success("New Kaya has been registered.", {
                autoClose: 7000,
              });
              setIndex(index + 1);
              setLoading(false);
              setSubmitting(false);
              resetForm();
            }
          })
          .catch((error) => {
            toast.error(error.message, { autoClose: 7000 });
            setLoading(false);
            setSubmitting(false);
          });
      }, 500);
    },
  });

  useEffect(() => {
    setTimeout(() => {
      buildingCRUD
        .loadBuildingAutoComplete(100, 0, value)
        .then((resp) => {
          // Format data for react-select
          const formattedData = resp.data.results.map((item) => ({
            value: item.id,
            label: `${item.house_no} - ${item.boundary_id?.boundary_name || 'N/A'}`
          }));
          setBuilding(formattedData);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {});
    }, 500);
  }, [value]);

  // Pre-select building if buildingId is provided (from Building Details page)
  useEffect(() => {
    if (buildingId) {
      buildingCRUD
        .loadBuildingDetail(buildingId)
        .then((resp) => {
          const buildingData = resp.data;
          const option = {
            value: buildingData.id,
            label: `${buildingData.house_no} - ${buildingData.boundary_id?.boundary_name || 'N/A'}`
          };
          setSelectedBuilding(option);
          formik.setFieldValue("building_id", buildingData.id);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [buildingId]);

  const handleInputChange = (inputValue) => {
    setValue(inputValue);
  };

  return (
    <>
      <div
        className="modal fade bs-example-modal-lg"
        tabindex="-1"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header bg-soft-primary">
              <h5 className="modal-title d-flex align-items-center" id="myLargeModalLabel">
                <i className="ri-home-smile-2-line fs-18 me-2 text-primary"></i>
                New Household (Kaya)
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <form onSubmit={formik.handleSubmit}>
              <div className="modal-body" style={{ maxHeight: "calc(100vh - 220px)", overflowY: "auto" }}>

                {/* ── Section 1: Household info ─────────────────────── */}
                <h6 className="text-primary fw-semibold mb-3">
                  <i className="ri-information-line align-bottom me-1"></i>
                  Household Information
                </h6>
                <div className="row g-3">
                  <div className="col-md-4 col-sm-12">
                    <div class="mb-3">
                      <label for="building_id" class="form-label">
                        Building
                      </label>
                      <Select
                        options={building}
                        value={selectedBuilding}
                        onChange={(selected) => {
                          setSelectedBuilding(selected);
                          formik.setFieldValue("building_id", selected ? selected.value : "");
                        }}
                        onInputChange={handleInputChange}
                        placeholder="Select Building"
                        isClearable={!buildingId}
                        isSearchable
                        isDisabled={!!buildingId}
                        noOptionsMessage={() => "No buildings found"}
                        styles={{
                          control: (base) => ({
                            ...base,
                            minHeight: "38px",
                          }),
                        }}
                      />
                      {formik.touched.building_id &&
                        formik.errors.building_id && (
                          <div
                            className="fw-light h6 mt-1"
                            style={{ fontSize: "15px" }}
                          >
                            <span role="alert" className="text-danger">
                              {formik.errors.building_id}
                            </span>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="mb-3">
                      <label for="head_phone_number" className="form-label">
                        Head Phone Number <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="head_phone_number"
                        {...formik.getFieldProps("head_phone_number")}
                        className="form-control"
                        placeholder="Head Phone Number"
                      />
                      {formik.touched.head_phone_number &&
                        formik.errors.head_phone_number && (
                          <div
                            className="fw-light h6 mt-1"
                            style={{ fontSize: "15px" }}
                          >
                            <span role="alert" className="text-danger">
                              {formik.errors.head_phone_number}
                            </span>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="mt-4">
                      <div class="form-check form-switch form-switch-left form-check-success form-switch-md">
                        <input
                          class="form-check-input code-switcher"
                          checked={formik.values.is_toilet_available}
                          {...formik.getFieldProps("is_toilet_available")}
                          type="checkbox"
                          id="is_toilet_available"
                        />
                        <label
                          for="is_toilet_available"
                          class="form-label text-muted"
                        >
                          Has Toilet Facility{" "}
                        </label>
                        <div className="row">
                          {formik.touched.is_toilet_available &&
                            formik.errors.is_toilet_available && (
                              <div
                                className="fw-light h6 mt-1"
                                style={{ fontSize: "15px" }}
                              >
                                <span role="alert" className="text-danger">
                                  {formik.errors.is_toilet_available}
                                </span>
                              </div>
                            )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row g-3">
                    <div className="col-md-6 col-sm-12">
                      <div className="mb-3">
                        <label className="form-label">Electricity Meter Number</label>
                        <input type="text" className="form-control" {...formik.getFieldProps("elecricity_meter_no")} placeholder="Electricity meter number" />
                      </div>
                    </div>
                    <div className="col-md-6 col-sm-12">
                      <div className="mb-3">
                        <label className="form-label">Water Meter Number</label>
                        <input type="text" className="form-control" {...formik.getFieldProps("water_meter_no")} placeholder="Water meter number" />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Distances now captured on the Building, not the household. */}
                <div className="row mt-2">
                  <div className="col-md-12 col-sm-12">
                    <div className="mb-3">
                      <label for="remarks" className="form-label">
                        <i className="ri-file-text-line align-bottom me-1 text-primary"></i>
                        Description / Remarks
                      </label>
                      <textarea
                        type="text"
                        rows={4}
                        id="remarks"
                        {...formik.getFieldProps("description")}
                        className="form-control"
                        placeholder="Any extra notes about the household (optional)"
                      ></textarea>
                      {formik.touched.remarks && formik.errors.remarks && (
                        <div
                          className="fw-light h6 mt-1"
                          style={{ fontSize: "15px" }}
                        >
                          <span role="alert" className="text-danger">
                            {formik.errors.remarks}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light fw-medium"
                  data-bs-dismiss="modal"
                >
                  <i className="ri-close-line me-1 align-middle"></i> Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={formik.isSubmitting || !formik.isValid}
                >
                  {!loading && (
                    <span className="indicator-label">
                      <i className="ri-save-3-line me-1 align-middle"></i> Save Household
                    </span>
                  )}
                  {loading && (
                    <span
                      className="indicator-progress"
                      style={{ display: "block" }}
                    >
                      Please wait...
                      <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                    </span>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
